import { useEffect } from 'react';
import Script from 'next/script';
import { useCartId, useCartUpdateAttributes } from '@backpackjs/storefront';

const fueledScriptUrl = process.env.NEXT_PUBLIC_FUELED_SCRIPT_URL || 'https://mb-cdn.fueled.io/fueled/53616c7465645f5fcaa90562d5c47b67f0bf839814184b25bbd6cc8495722e955af76bdd9f94440c3b77ce32952c84ab40e260d4301faab4d3ef98b522323d4c/packdigital/js';


export function FueledClientScript() {
  const cartId = useCartId();
  const { cartUpdateAttributes } = useCartUpdateAttributes();

  useEffect(() => {
    if (!cartId) return () => null;

    const setCartToken = async () => {
      const fueled = window.fueled || {};

      const res = await fueled.setFrontendStorage(
        fueled.config.frontendStorageUrl,
        cartId.replace('gid://shopify/Cart/', '')
      );

      const {
        context: {
          anonymousId,
          ga4: { clientId = undefined, sessionId = undefined } = {},
          fb: { fbp = undefined, fbc = undefined } = {},
        },
      } = await res.json();

      await cartUpdateAttributes({
        attributes: [
          {
            key: 'fueled_context',
            value: JSON.stringify({
              anonymousId,
              ga4: { clientId, sessionId },
              fb: { fbp, fbc },
            }),
          },
        ],
      });
    };

    if (window.fueled) {
      setCartToken();
    } else {
      window.addEventListener('fueled-ready', setCartToken);
    }

    return () => {
      window.removeEventListener('fueled-ready', setCartToken);
    };
  }, [cartId]);

  return <Script type="text/javascript" src={fueledScriptUrl} />;
}